import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  Typography
} from '@material-ui/core';


const MasterCountryTooltip = props => {
  const { t } = useTranslation();

  const {
    content,
    type = 'text',
    masterCountry
  } = props;

  const htmlContent = useMemo(() => {
    if (type === 'htmlList' && Array.isArray(content) && content.length > 0) {
      return `<ul>
        ${content.map(c => (`<li>${c}</li>`)).join('')}
      </ul>`
    } else {
      return content;
    }
  }, [type, content, masterCountry])


  return (
    <>
      <Typography variant="overline">{t(`countries:${masterCountry}`) + ` (${t('common:master')})`}</Typography>
      <Typography variant="subtitle1" component="div">
        {
          type === 'html' || type === 'htmlList'
            ?
            <div dangerouslySetInnerHTML={{__html: htmlContent}} />
            :
            content
        }
      </Typography>
    </>
  );


};

MasterCountryTooltip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  type: PropTypes.oneOf(['html', 'text', 'htmlList']),
  masterCountry: PropTypes.string
};

export default MasterCountryTooltip;
